import type { Props as ToastProps } from '@cencosud-cencommerce/paris-uikit/dist/molecules/Toast/Toast';

import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';
import type { SendGtmEvent } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { BuyNowEventInteractiveTags } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import type { PickupPersonFormValues } from '@/Pages/BuyNowPage/PaymentAndShipping/partials/PickupOptions/PickupPerson/interfaces';

export const LABEL_PICKUP_ANOTHER_PERSON = '¿Retira otra persona?';
export const LABEL_MODAL_TITLE = '¿Quién hará el retiro?';
export const LABEL_REQUIRED_FIELDS = '* Campos obligatorios';
export const LABEL_CTA = 'Guardar';

export const FIELD_DOCUMENT_ID = 'documentID' as const;
export const FIELD_PICKUP_PERSON_RUT = 'pickupPersonRut' as const;

export const DEFAULT_FORM_VALUES: PickupPersonFormValues = {
  completeName: '',
  pickupPersonRut: '',
  documentType: IdentificationDocumentTypes.RUT,
  documentID: ''
};

export const EVENT_TAG_PICKUP_ANOTHER_PERSON: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.RetiraOtraPersona
  }
};

export const TOAST_ADD_PICKUP_PERSON_SUCCESS: ToastProps = {
  title: 'Otra persona hará el retiro',
  body: 'Sus datos se guardaron con éxito.'
};

export const TOAST_ADD_PICKUP_PERSON_ERROR: ToastProps = {
  title: 'No pudimos editar los datos de retiro',
  body: 'Por favor, vuelve a intentarlo.',
  status: 'error'
};

export const TOAST_DELETE_SUCCESS: ToastProps = {
  title: 'Eliminaste los datos de retiro',
  body: 'Tú retirarás la compra.'
};

export const TOAST_DELETE_ERROR: ToastProps = {
  title: 'No se pudo eliminar los datos de retiro',
  body: 'Por favor, intenta de nuevo.',
  status: 'error'
};
